import styled from "styled-components";
import { Card as KosmosCard } from "kosmos-ui";

export const ShopperOrderBaseCard = styled(KosmosCard)`
  && {
    background-color: ${({ theme }) => theme.colorsPalette.black.lighter};
    margin-bottom: 16px;
    flex-direction: row;
    padding: 24px;
    align-items: center;
  }
`;

export const ShopperOrderConfirmationNoContainer = styled.div`
  width: 136px;
`;

export const ShopperOrderAmountContainer = styled.div`
  width: 142px;
`;

export const ShopperOrderAmountSubContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ShopperOrderProductNoContainer = styled.div`
  width: 140px;
`;

export const ShopperOrderStatusContainer = styled.div`
  width: 132px;
`;
